import type { CSSProperties, ReactNode } from "react";

export interface SkeletonProps {
  readonly width?: number | string;
  readonly height?: number | string;
  readonly radius?: number;
}

// A single shimmer block. Honors prefers-reduced-motion via .skeleton CSS.
export const Skeleton = ({ width = "100%", height = 16, radius }: SkeletonProps): ReactNode => {
  const style: CSSProperties = { width, height };
  if (radius !== undefined) {
    style.borderRadius = radius;
  }
  return <div className="skeleton" style={style} />;
};

// Several stacked lines — a generic loading body for a card.
const LINE_HEIGHT = 14;
const WIDTH_STEP = 12;
const FULL_WIDTH = 100;

export const SkeletonLines = ({ count = 3 }: { readonly count?: number }): ReactNode => (
  <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
    {Array.from({ length: count }, (_, i) => `line-${i}`).map((id, i) => (
      <Skeleton key={id} height={LINE_HEIGHT} width={`${FULL_WIDTH - i * WIDTH_STEP}%`} />
    ))}
  </div>
);
